module.exports = __webpack_public_path__ + "static/media/pet-race-final.c42c62c0.svg";